<template>
  <Checks />
</template>

<script>
import Checks from "../../components/Checks/Checks.vue";

export default {
  components: { Checks },
};
</script>
